export enum ProcessPaymentType {
    GatewayPayment = 'GatewayPayment',
    MewsTerminalPayment = 'MewsTerminalPayment',
    PaymentRequest = 'PaymentRequest',
    ExternalCardPayment = 'ExternalCardPayment',
    CashPayment = 'CashPayment',
    ExternalPayment = 'ExternalPayment',
    TokenizeCard = 'TokenizeCard',
    RecordCard = 'RecordCard',
    GatewayCardPreauth = 'GatewayCardPreauth',
    ExternalCardPreauth = 'ExternalCardPreauth',
    MewsTerminalPreauth = 'MewsTerminalPreauth',
}

export const getDataTestIdForPaymentType = (paymentType: ProcessPaymentType) => `payment-option-${paymentType}`;
